import Vue from 'vue';
import moment from 'moment';
import store from '../store/store';

// Please do not use constants for dynamic language as they cannot be changed during runtime
// e.g. return moment(date).locale(store.state.user.language).format('LLLL');
const userLanguage = 'de';

Vue.filter('formatDateShort', (date) => {
  if (moment(date).isValid()) {
    return moment(date).locale(userLanguage).format('L');
  }
  return date;
});

Vue.filter('formatDateMedium', (date) => {
  if (moment(date).isValid()) {
    return moment(date).locale(userLanguage).format('LL');
  }
  return date;
});

Vue.filter('formatDateLong', (date) => {
  if (moment(date).isValid()) {
    return moment(date).locale(userLanguage).format('LLL');
  }
  return date;
});

Vue.filter('formatDateMonth', (date) => {
  if (moment(date).isValid()) {
    return moment(date).locale(store.state.user.language).format('MMMM YYYY');
  }
  return date;
});

Vue.filter('formatUnixTimestampMedium', (date) => {
  if (moment(date).isValid()) {
    return moment.unix(date).locale(userLanguage).format('LL');
  }
  return date;
});

Vue.filter('formatTimestamp', (date) => {
  if (moment(date).isValid()) {
    return moment(date).locale(userLanguage).format('LLLL');
  }
  return date;
});

Vue.filter('formatJobWorkload', (job) => {
  const min = job.workload_min;
  const max = job.workload_max;

  if (min === max) {
    return min;
  } if (min === 0 || min === null) {
    return max;
  } if (max === 0 || max === null) {
    return min;
  } return `${min} - ${max}`;
});

Vue.filter('lowercase', (string) => string.toLowerCase());
